import React, { useState, useEffect } from 'react';
import 'tailwindcss/tailwind.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faHourglassHalf} from '@fortawesome/free-solid-svg-icons'
import { motion } from "framer-motion";



const CuentaRegresiva = () => {
  const [dias, setDias] = useState(0);
  const [horas, setHoras] = useState(0);
  const [minutos, setMinutos] = useState(0);
  const [segundos, setSegundos] = useState(0);

  useEffect(() => {
    const fechaBoda = new Date('2025-11-15T20:00:00');
    const intervalo = setInterval(() => {
      const ahora = new Date();
      const diferencia = fechaBoda.getTime() - ahora.getTime();
      const dias = Math.floor(diferencia / (1000 * 60 * 60 * 24));
      const horas = Math.floor((diferencia % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutos = Math.floor((diferencia % (1000 * 60 * 60)) / (1000 * 60));
      const segundos = Math.floor((diferencia % (1000 * 60)) / 1000);
      setDias(dias);
      setHoras(horas);
      setMinutos(minutos);
      setSegundos(segundos);
    }, 1000);
    return () => clearInterval(intervalo);
  }, []);

  

  return (
    <div className="bg-verde2 text-white p-8 rounded-lg shadow-lg flex flex-col justify-center items-center h-full">
      <div className="text-3xl text-center mb-6 flex items-center justify-center">
       <motion.div
  animate={{ rotate: 360 }}
  transition={{ repeat: Infinity, duration: 15, ease: "linear" }}
>
  <FontAwesomeIcon icon={faHourglassHalf} className="mr-2" />
</motion.div>
        <h2 className="text-6xl font-atentamente">¡Faltan!</h2>
      </div>

      <div className="grid grid-cols-4 gap-2 text-center">
        {/* Días */}
        <div className="flex flex-col items-center">
          <div className="w-16 h-16 flex items-center justify-center relative">
                      <motion.svg
  viewBox="0 0 24 24"
  className="absolute w-[80px] h-[80px] text-white"
  fill="white"
  animate={{ scale: [1, 1.1, 1] }}          // late: normal → grande → normal
  transition={{ repeat: Infinity, duration: 1, ease: "easeInOut" }} // velocidad
>
  <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 
           2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09 
           C13.09 3.81 14.76 3 16.5 3 
           19.58 3 22 5.42 22 8.5 
           c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
</motion.svg>
            <div className="text-3xl text-verde2 font-bold relative z-10">
              {dias}
            </div>
          </div>
          <div className="text-sm mt-1">Días</div>
        </div>

        {/* Horas */}
        <div className="flex flex-col items-center">
          <div className="w-16 h-16 flex items-center justify-center relative">
                    <motion.svg
  viewBox="0 0 24 24"
  className="absolute w-[80px] h-[80px] text-white"
  fill="white"
  animate={{ scale: [1, 1.1, 1] }}          // late: normal → grande → normal
  transition={{ repeat: Infinity, duration: 1, ease: "easeInOut" }} // velocidad
>
  <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 
           2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09 
           C13.09 3.81 14.76 3 16.5 3 
           19.58 3 22 5.42 22 8.5 
           c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
</motion.svg>
            <div className="text-3xl text-verde2 font-bold relative z-10">
              {horas}
            </div>
          </div>
          <div className="text-sm mt-1">Horas</div>
        </div>

        {/* Minutos */}
        <div className="flex flex-col items-center">
          <div className="w-16 h-16 flex items-center justify-center relative">
                    <motion.svg
  viewBox="0 0 24 24"
  className="absolute w-[80px] h-[80px] text-white"
  fill="white"
  animate={{ scale: [1, 1.1, 1] }}          // late: normal → grande → normal
  transition={{ repeat: Infinity, duration: 1, ease: "easeInOut" }} // velocidad
>
  <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 
           2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09 
           C13.09 3.81 14.76 3 16.5 3 
           19.58 3 22 5.42 22 8.5 
           c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
</motion.svg>
            <div className="text-3xl text-verde2 font-bold relative z-10">
              {minutos}
            </div>
          </div>
          <div className="text-sm mt-1">Minutos</div>
        </div>

        {/* Segundos */}
        <div className="flex flex-col items-center">
          <div className="w-16 h-16 flex items-center justify-center relative">
           <motion.svg
  viewBox="0 0 24 24"
  className="absolute w-[80px] h-[80px] text-white"
  fill="white"
  animate={{ scale: [1, 1.1, 1] }}          // late: normal → grande → normal
  transition={{ repeat: Infinity, duration: 1, ease: "easeInOut" }} // velocidad
>
  <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 
           2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09 
           C13.09 3.81 14.76 3 16.5 3 
           19.58 3 22 5.42 22 8.5 
           c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
</motion.svg>
            <div className="text-3xl text-verde2 font-bold relative z-10">
              {segundos}
            </div>
          </div>
          <div className="text-sm mt-1">Segundos</div>
        </div>
      </div>
    </div>
  );
};


export default CuentaRegresiva;
